import { render, staticRenderFns } from "./kabala-avatar.vue?vue&type=template&id=1d5c874b&scoped=true&"
import script from "./kabala-avatar.vue?vue&type=script&lang=js&"
export * from "./kabala-avatar.vue?vue&type=script&lang=js&"
import style0 from "./kabala-avatar.vue?vue&type=style&index=0&id=1d5c874b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5c874b",
  null
  
)

export default component.exports